import React from "react";
import {
	Box,
	Grid,
	Alert,
	Button,
	Checkbox,
	Typography,
} from "@mui/material";
import {
	makeStyles
} from "@mui/styles";
import {
	VisibleContent
} from "../../../../../components";
import {
	KeyboardBackspace as KeyboardBackspaceIcon
} from "@mui/icons-material";
import {
	Notification,
	notificationTypes
} from "../../../../../common/Notification";
import {formatTimeHourWithNumerals, getNumeral} from "../../../../../utils/numerals";

const WorkList = (props) => {
	const {
		works,
		isUpdateWorks,
		onCancelWorks,
		onUpdateWorks,
		onCompleteWorks,
		onOpenMultiMedia,
		onChangeStatusWork
	} = props;
	const isEmpty = Boolean(works.length === 0);
	const classes = useStyles();

	const [workGroups, setWorkGroups] = React.useState([]);
	const initWorkGroups = () => {
		if (works.length === 0) {
			setWorkGroups([])
			return
		}

		let _workGroups = [];
		works.map((work) => {
			const mechanicId = work?.mechanic?.id || null;
			const workStatus = work?.executionStatus;
			const keyElement = [mechanicId, workStatus].join('-');

			if (!Boolean(_workGroups.find((t) => t.index === keyElement))) {
				_workGroups.push({
					index: keyElement,
					mechanicId: mechanicId,
					mechanicName: [work?.mechanic?.firstName, work?.mechanic?.lastName].filter((t) => !!t).join(' '),
					works: []
				});
			}
			_workGroups.find((t) => t.index === keyElement).works.push(work);
		});
		_workGroups.sort((a, b) => {
			if (a.mechanicId === null && b.mechanicId !== null) return -1;
			if (a.mechanicId !== null && b.mechanicId === null) return 1;
			return 0;
		});
		setWorkGroups(_workGroups);
	};
	React.useEffect(() => {
		initWorkGroups();
	}, [works]);

	return (
		<Box className={classes.root}>
			<Grid container alignItems="flex-end" justifyContent="space-between">
				<Grid item>
					<Typography variant="h3" textAlign="left">Работы</Typography>
				</Grid>
				<Grid item>
					<Grid container spacing={1}>
						<Grid item>
							<Button variant="contained" onClick={onOpenMultiMedia}>Мультимедиа</Button>
						</Grid>
						<Grid item>
							<Button
								variant="contained"
								disabled={isUpdateWorks}
								onClick={onUpdateWorks}
							>Обновить</Button>
						</Grid>
					</Grid>
				</Grid>
			</Grid>
			<VisibleContent visible={!isEmpty}>
				<Box mt={1}/>
				<Grid container spacing={1}>
					{workGroups.map((item) => {
						const CardItem = Boolean(item.mechanicId) ?  WorkCardInMechanic : WorkCardWithoutMechanic;
						return (
							<Grid key={`workGroups-${ item.index }`} item xs={12} lg={6}>
								<CardItem
									{...item}
									onCancelWorks={onCancelWorks}
									onCompleteWorks={onCompleteWorks}
									onChangeStatusWork={onChangeStatusWork}
								/>
							</Grid>
						)
					})}
				</Grid>
			</VisibleContent>
			<VisibleContent visible={isEmpty}>
				<Box mt={1}/>
				<Alert severity="error">
					В заказе нет работ
				</Alert>
			</VisibleContent>
		</Box>
	)
}

const WorkCardInMechanic = (props) => {
	const {
		works,
		mechanicId,
		mechanicName,
		onChangeStatusWork
	} = props;
	const classes = useStyles();
	const currentStatus = works?.[0]?.executionStatus || '';

  const groupedWorks = React.useMemo(() => {
    if (!works || works.length === 0) {
      return [];
    }

    // Группировка по executionStartedAt и executionFinishedAt
    const groupsMap = new Map();

    works.forEach((work) => {
      const executionStartedAt = work?.executionStartedAt || null;
      const executionFinishedAt = work?.executionFinishedAt || null;

      // Создаем ключ для группировки
      const groupKey = `${executionStartedAt || 'null'}-${executionFinishedAt || 'null'}`;

      // Берем только одно значение из группы (первое найденное)
      if (!groupsMap.has(groupKey)) {
        groupsMap.set(groupKey, {
          executionStartedAt,
          executionFinishedAt,
          work: work,
          totalTimeMinutes: work?.executionTimeMinutes || 0
        });
      }
    });

	console.log('groupsMap: ', groupsMap)

    // Преобразуем Map в массив
    return Array.from(groupsMap.values());
  }, [works]);

  // Вычисляем общее время из всех групп для обратной совместимости
  const totalTime = React.useMemo(() => {
    return groupedWorks.reduce((acc, group) => acc + group.totalTimeMinutes, 0);
  }, [groupedWorks]);

	const [selectedWorksIds, setSelectedWorksIds] = React.useState([]);
	const handleChangeSelectedWorksIds = (work) => {
		const workId = work?.id;
		if (selectedWorksIds.length >= 4 && !selectedWorksIds.includes(workId)) {
			return
		}
		let _selectedWorksIds = [...selectedWorksIds];
		if (_selectedWorksIds.includes(workId)) {
			_selectedWorksIds.splice(_selectedWorksIds.indexOf(workId), 1);
		} else {
			_selectedWorksIds.push(workId);
		}
		setSelectedWorksIds(_selectedWorksIds);
	}

	const [actionType, setActionType] = React.useState('');
	const handleChangeActionType = (type) => {
		if (selectedWorksIds.length <= 0) {
			Notification({
				type: notificationTypes.error,
				message: "Выберите работы"
			})
			return;
		}
		setActionType(type);
		if (type === 'cancel') {
			handleCancelWorks();
			return
		}
		if (type === 'pause') {
			handlePauseWorks();
			return;
		}
		if (type === 'completed') {
			handleCompleteWorks();
			return;
		}
	}

	const [statusWords, setStatusWords] = React.useState(() => {
		if (currentStatus === 'paused') {
			return 'Пауза'
		}
		if (currentStatus === 'in_progress') {
			return 'В работе'
		}
		if (currentStatus === 'completed') {
			return 'Завершен'
		}
		return currentStatus
	});

	const getMessageFinalTime = () => {
		let count = works.length;
		return [
			`на ${ count } ${ getNumeral(count, ['задача','задачи','задач']) }`,
			formatTimeHourWithNumerals(totalTime)
		].join(' - ')
	}
	const getMessageTotalTime = () => {
		let time = 0; let count = 0;
		if (!actionType) {
			count = works.length;
			time = [...works].reduce((acc, work) => {
				return acc + (work.estimate || 0)
			}, 0)
		} else {
			count = selectedWorksIds.length;
			time = works.filter((t) => selectedWorksIds.includes(t.id)).map((t) => (t.estimate || 0)).reduce((acc, work) => {
				return acc + (work || 0)
			}, 0);
		}

		return [
			`${ count } ${ getNumeral(count, ['задача','задачи','задач']) }`,
			formatTimeHourWithNumerals(time)
		].join(' - ')
	}

	const handleStartWorks = () => {
		const status = Boolean(currentStatus === 'pending') ? 'start' : 'resume';
		onChangeStatusWork(selectedWorksIds, status, false);
		setSelectedWorksIds([])
	}
	const handlePauseWorks = () => {
		onChangeStatusWork(selectedWorksIds, 'pause', false);
		setActionType('');
		setSelectedWorksIds([]);
	}
	const handleCancelWorks = () => {
		if (selectedWorksIds.length <= 0) {
			Notification({
				type: notificationTypes.warning,
				message: "Выберите работы от которых хотите отказаться"
			})
			return;
		}
		onChangeStatusWork(selectedWorksIds, 'cancel', false);
		setActionType('');
		setSelectedWorksIds([]);
	}
	const handleCompleteWorks = () => {
		onChangeStatusWork(selectedWorksIds, 'finish', false);
		setActionType('');
		setSelectedWorksIds([]);
	}

	const _getTimeInEstimate = (estimate) => {
		return formatTimeHourWithNumerals(estimate)
	}

	return (
		<Box className={classes.workCard}>
			<Typography className={classes.workCardTitle}>
				Работы механика "{ mechanicName }"
				<Typography className={classes.workCardTotalTime}>
					Текущий статус: { statusWords }
				</Typography>
			</Typography>
			<div className="divider"/>
			<Box className={classes.workCardBody}>
				{works.map((item) => (
					<div
						className={classes.workCardCheckboxRow}
						onClick={handleChangeSelectedWorksIds.bind(this, item)}
					>
						<Grid container spacing={1} wrap="nowrap" alignItems="center">
							<Grid item>
								<Checkbox
									disabled={selectedWorksIds.length >= 4 && !selectedWorksIds.includes(item.id)}
									value={selectedWorksIds.includes(item.id)}
									checked={selectedWorksIds.includes(item.id)}
								/>
							</Grid>
							<Grid item sx={{flex: 'auto'}}>
								<Typography className={classes.workCardNameWork}>
									{item?.description || ''}
									<span style={{marginLeft: '4px', fontSize: 12, fontWeight: "500", color: "#006FBA"}}>({_getTimeInEstimate(item.estimate)})</span>
								</Typography>
							</Grid>
						</Grid>
					</div>
				))}
			</Box>
			<div className="divider"/>
			<VisibleContent visible={currentStatus !== 'completed'}>
				<Typography className={classes.workCardTotalTime}>
					Итого: {getMessageTotalTime()}
				</Typography>
				<div className="divider"/>
				<Box className={classes.workCardActions}>
					<Grid container spacing={1} wrap="nowrap">
						<VisibleContent visible={['in_progress'].includes(currentStatus)}>
							<Grid item>
								<Button variant="contained" onClick={handleChangeActionType.bind(this, 'pause')}>
									Пауза
								</Button>
							</Grid>
							<Grid item>
								<Button variant="contained" onClick={handleChangeActionType.bind(this, 'completed')}>
									Завершить
								</Button>
							</Grid>
							<Grid item sx={{marginLeft: "auto"}}>
								<Button variant="outlined" color="error" onClick={handleChangeActionType.bind(this, 'cancel')}>
									Отменить
								</Button>
							</Grid>
						</VisibleContent>
						<VisibleContent visible={['pending', 'paused'].includes(currentStatus)}>
							<Grid item>
								<Button variant="contained" onClick={handleStartWorks}>
									{mechanicId ? 'Продолжить' : 'Выполнить'}
								</Button>
							</Grid>
						</VisibleContent>
					</Grid>
				</Box>
			</VisibleContent>
			<VisibleContent visible={currentStatus === 'completed'}>
				<Typography className={classes.workCardTotalTime}>
					Затрачено: {getMessageFinalTime()}
				</Typography>
			</VisibleContent>
		</Box>
	)
}
const WorkCardWithoutMechanic = (props) => {
	const {
		works,
		mechanicId,
		mechanicName,
		onChangeStatusWork
	} = props;
	const classes = useStyles();

	const [selectedWorksIds, setSelectedWorksIds] = React.useState([]);
	const handleChangeSelectedWorksIds = (work) => {
		const workId = work?.id;
		if (selectedWorksIds.length >= 4 && !selectedWorksIds.includes(workId)) {
			return
		}
		let _selectedWorksIds = [...selectedWorksIds];
		if (_selectedWorksIds.includes(workId)) {
			_selectedWorksIds.splice(_selectedWorksIds.indexOf(workId), 1);
		} else {
			_selectedWorksIds.push(workId);
		}
		setSelectedWorksIds(_selectedWorksIds);
	}
	const getMessageTotalTime = () => {
		let time = 0; let count = 0;
		if (mechanicId) {
			count = works.length;
			time = [...works].reduce((acc, work) => {
				return acc + (work.estimate || 0)
			}, 0)
		} else {
			count = selectedWorksIds.length;
			time = works.filter((t) => selectedWorksIds.includes(t.id)).map((t) => (t.estimate || 0)).reduce((acc, work) => {
				return acc + (work || 0)
			}, 0);
		}

		return [
			`${ count } ${ getNumeral(count, ['задача','задачи','задач']) }`,
			formatTimeHourWithNumerals(time)
		].join(' - ')
	}
	const handleStartWorks = () => {
		onChangeStatusWork(selectedWorksIds, 'start', false);
		setSelectedWorksIds([])
	}
	const _getTimeInEstimate = (estimate) => {
		return formatTimeHourWithNumerals(estimate)
	}

	return (
		<Box className={classes.workCard}>
			<Typography className={classes.workCardTitle}>
				{mechanicId ? `Работы механика "${ mechanicName }"` : 'Свободные работы'}
			</Typography>
			<div className="divider"/>
			<Box className={classes.workCardBody}>
				{works.map((item) => (
					<div
						className={classes.workCardCheckboxRow}
						onClick={handleChangeSelectedWorksIds.bind(this, item)}
					>
						<Grid container spacing={1} wrap="nowrap" alignItems="center">
							<VisibleContent visible={!mechanicId}>
								<Grid item>
									<Checkbox
										disabled={selectedWorksIds.length >= 4 && !selectedWorksIds.includes(item.id)}
										value={selectedWorksIds.includes(item.id)}
										checked={selectedWorksIds.includes(item.id)}
									/>
								</Grid>
							</VisibleContent>
							<VisibleContent visible={mechanicId}>
								<Grid item>
									<Typography className={classes.workCardNameWork}>
										·
									</Typography>
								</Grid>
							</VisibleContent>
							<Grid item sx={{flex: 'auto'}}>
								<Typography className={classes.workCardNameWork}>
									{item?.description || ''}
									<span style={{marginLeft: '4px', fontSize: 12, fontWeight: "500", color: "#006FBA"}}>({_getTimeInEstimate(item.estimate)})</span>
								</Typography>
							</Grid>
						</Grid>
					</div>
				))}
			</Box>

			<VisibleContent visible={selectedWorksIds.length > 0}>
				<div className="divider"/>
				<Typography className={classes.workCardTotalTime}>
					Итого: {getMessageTotalTime()}
				</Typography>
				<div className="divider"/>
				<Box className={classes.workCardActions}>
					<Button variant="outlined" className="start" fullWidth onClick={handleStartWorks}>
						Выполнить
					</Button>
				</Box>
			</VisibleContent>
		</Box>
	)
}

const useStyles = makeStyles(() => ({
	root: {},

	workCard: {
		padding: "12px 14px",
		background: "white",
		borderRadius: "16px",
		boxSizing: "border-box",
		border: "1px solid #1524351A",
		// boxShadow: "0px 3px 5px 0px #00000014",

		"& .divider": {
			margin: "10px -14px",
			height: "1px",
			backgroundColor: "#1524351A",
		}
	},
	workCardTitle: {
		fontSize: "16px",
		color: "#231F20",
		lineHeight: "18px",
		fontWeight: "600",
	},
	workCardBody: {
		margin: "-8px 0",
		"& .MuiCheckbox-root": {
			padding: 0
		},
		"& .MuiSvgIcon-root": {
			width: 20,
			height: 20,
		}
	},
	workCardNameWork: {
		fontSize: "14px",
		color: "#808083",
		lineHeight: "16px",
		letterSpacing: "-0.02em",
	},
	workCardTotalTime: {
		fontSize: "13px",
		lineHeight: "14px",
		color: "#006FBA"
	},
	workCardCheckboxRow: {
		display: "flex",
		width: "100%",
		padding: "8px 0",
		boxSizing: "border-box",
	},
	workCardActions: {
		"& .start": {
			borderRadius: "100px",
			fontSize: "15px",
			height: "36px",
		}
	}
}));

export default WorkList
